<template>
  <v-layout row justify-center>
    <v-dialog class="modal-dialog"
      v-model="dialog"
      max-width="290"
      persistent
    >
      <v-card>
        <v-card-title class="modal-headline" id="dialogTitle">{{dialogTitle}}</v-card-title>

        <v-card-text v-html="dialogMessage" id="dialogMessage">
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class='modal-confirm-button'
            flat="flat"
            @click="closeModal"
            id="dialogButton"
          >
            {{dialogButtonText}}
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>

export default {
  name: 'ModalDialog',
  props: ['dialog', 'dialogMessage', 'dialogTitle', 'dialogButtonText'],
  methods: {
    closeModal () {
      this.$emit('closemodal')
    }
  }
}

</script>
<style lang="scss">
.modal-confirm-button {
  background-color: var(--primary-btn-bg-color) !important;
  color: var(--primary-btn-text-color) !important;
}
.modal-headline{
  background-color: var(--primary-color) !important;
  color: var(--primary-bg-text-color) !important;
}
</style>
